import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Button, Box, Grid } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';
import Header from '../HeaderComponent/Header';
import Footer from '../FooterComponent/Footer';
import UserProfile from '../userProfile/UserProfile';

const AboutBUPage = () => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleAccordionChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleBackClick = () => {
    navigate('/dashboard');
  };

  const description = `PTS - Business Unit`;

  return (
    <>
      <UserProfile />
      <div style={{ flex: '0 1 auto' }}>
        <Header headDescription={description} />
      </div>
      <Box sx={{ maxHeight: '100vh', overflowY: 'scroll', padding: 2, '&::-webkit-scrollbar': { width: '12px' }, '&::-webkit-scrollbar-track': { background: '#f1f1f1' }, '&::-webkit-scrollbar-thumb': { background: '#888' }, '&::-webkit-scrollbar-thumb:hover': { background: '#555' } }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h2" gutterBottom sx={{
              fontFamily: 'Helvetica Neue',
              fontSize: { xs: 16, sm: 20 }, // Responsive font size
              fontWeight: 700,
              lineHeight: '24.42px',
              textAlign: 'center',
              color: '#0047BA !important'
            }}>
              About Business Units
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Accordion expanded={expanded === 'panel1'} onChange={handleAccordionChange('panel1')}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography sx={{
                  fontFamily: 'Helvetica Neue',
                  fontSize: { xs: 16, sm: 20 }, // Responsive font size
                  fontWeight: 700,
                  lineHeight: '24.42px',
                  textAlign: 'center',
                  color: '#0047BA !important',
                  width: '100%'
                }}>PTRA</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ font: 'normal normal 14px Segoe UI', paddingTop: '20px' }}>
                  pepsilogistics@pepsico.com: This is the Traditional team – We handle Dairy Farmers America Bottles, DFA orders, Frito Lay, Plant to Plant Transfers, Special Events, Projects, and R&D orders. Most of orders require Cost Center, DIVLOC, PEPLOC or Account number depending on what location they are being shipped into.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid item xs={12}>
            <Accordion expanded={expanded === 'panel2'} onChange={handleAccordionChange('panel2')}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography sx={{
                  fontFamily: 'Helvetica Neue',
                  fontSize: { xs: 16, sm: 20 }, // Responsive font size
                  fontWeight: 700,
                  lineHeight: '24.42px',
                  textAlign: 'center',
                  color: '#0047BA !important',
                  width: '100%'
                }}>PBCI</Typography>
              </AccordionSummary>
              <AccordionDetails>

                <Box sx={{ maxHeight: 200, overflowY: 'scroll', scrollbarWidth: 'thin', '&::-webkit-scrollbar': { width: '12px' }, '&::-webkit-scrollbar-track': { background: '#f1f1f1' }, '&::-webkit-scrollbar-thumb': { background: '#888' }, '&::-webkit-scrollbar-thumb:hover': { background: '#555' } }}>
                  <Typography sx={{ font: 'normal normal 14px Segoe UI', paddingTop: '20px' }}>
                    spapeplogisticspbc@pepsico.com - Pepsi Bottle Company Team: This will include all COLD-Fill bottlers.
                    This team handles orders for Pepsi plants to include:
                    <ul>
                      <li>Cans</li>
                      <li>Lids</li>
                      <li>Preforms</li>
                      <li>Labels</li>
                      <li>Corrugate</li>
                      <li>Dunnage for the Pepsi plants</li>
                      <li>Rockstar plants</li>
                      <li>Dry Sugar</li>
                      <li>Shrink Wrap</li>
                      <li>Closures</li>
                      <li>BIB</li>
                      <li>Paperboard</li>
                      <li>Perm Merchandise</li>
                      <li>North American Coffee Partnership</li>
                      <li>Canadian Pepsi Bottlers</li>
                    </ul>
                  </Typography>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid item xs={12}>
            <Accordion expanded={expanded === 'panel3'} onChange={handleAccordionChange('panel3')}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography sx={{
                  fontFamily: 'Helvetica Neue',
                  fontSize: { xs: 16, sm: 20 }, // Responsive font size
                  fontWeight: 700,
                  lineHeight: '24.42px',
                  textAlign: 'center',
                  color: '#0047BA !important',
                  width: '100%'
                }}>PQGI</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ font: 'normal normal 14px Segoe UI', paddingTop: '20px' }}>
                  logistics_qginbound@pepsico.com- This is the Quaker and Gatorade Team. They will handle ingredients for the plants to produce product for Quaker and Gatorade. This will include labels, bottles, corrugate, seasoning that include salts and sugars. Orders will require a 10-digit PO starting with a 45 or 76
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
            <Box sx={{
              position: "fixed",
              bottom: "60px", // Space above the footer
              left: { xs: '1rem', sm: '8rem' }, // Responsive left position
              width: { xs: "90%", sm: "80%" }, // Responsive width
              display: "flex",
              justifyContent: "space-between", // Left and right alignment
              alignItems: "center"
            }}>
              <Button variant="contained" style={{
                backgroundColor: '#F6EB39', color: '#2E2E38', fontFamily: 'Helvetica Neue',
                fontSize: '14px', fontWeight: 700, lineHeight: '22px', textAlign: 'left',
              }} onClick={handleBackClick} sx={{ mr: 2 }}>
                Back
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <div style={{ flex: '0 1 auto', position: 'fixed', bottom: 0, width: '100%', backgroundColor: 'white', overflow: 'hidden' }}>
        <Footer />
      </div>
    </>
  );
};

export default AboutBUPage;